import { isSysError } from '~/util/typeguards';

const mapErrorToObject = (
  error: AppError | null = {},
  status?: number
): MappedError => {
  if (typeof error === 'undefined' || !error) return undefined as any;
  // Errors returned by JavaScript need to be
  // manually mapped else they just look like `error: { }`
  // in the returned JSON
  if (isSysError(error)) {
    return {
      status:
        error.status || status || error.cause === 'validation' ? 422 : 500,
      code: error.code,
      type: `${error.cause}`,
      message: error.message,
      data: error.data, // Added a data prop so we can return data back with thrown errors
      stack: error.stack,
    };
  }
  // Errors returned from the API are JSON objects and could be
  // passed directly to our response, instead we can flatten the
  // error.data.data[] array and remove unneccessary elements here
  return {
    status: error.status || status,
    statusText: error.statusText,
    url: error.url,
    message: error.data
      ? error.data.message ||
        error.data.Message ||
        error.data.error ||
        error.data.Error ||
        (error as MappedError).message
      : undefined,
    type: error.data
      ? error.data.type || error.data.Type || (error as MappedError).type
      : undefined,
    data: error?.data?.data || error?.data?.Data || undefined,
    logId:
      error?.data?.logId ||
      error?.data?.LogId ||
      (error as MappedError).logId ||
      undefined,
  };
};

export default mapErrorToObject;
